module.exports = __webpack_public_path__ + "static/media/fluxwheel_square.af07711c.jpg";